
export default function Pricing() {
  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const volumePricing = [
    { label: '1/8 Truck', price: '$130', icon: 'ri-truck-line', fill: 'w-2/12' },
    { label: '1/4 Truck', price: '$220 - $260', icon: 'ri-truck-line', fill: 'w-3/12' },
    { label: '1/2 Truck', price: '$340 - $480', icon: 'ri-truck-line', fill: 'w-5/12' },
    { label: '3/4 Truck', price: '$480 - $700', icon: 'ri-truck-line', fill: 'w-8/12' },
    { label: 'Full Truck', price: '$600 - $850', icon: 'ri-truck-line', fill: 'w-full' },
  ];

  const singleItems = [
    { label: 'Sofa', price: '$140 - $199', icon: 'ri-sofa-line' },
    { label: 'Mattress', price: '$120 - $140', icon: 'ri-hotel-bed-line' },
    { label: 'Refrigerator', price: '$130 - $160', icon: 'ri-fridge-line' },
    { label: 'Hot Tub', price: '$350 - $600', icon: 'ri-drop-line' },
    { label: 'Treadmill', price: '$180 - $220', icon: 'ri-run-line' },
  ];

  return (
    <section id="pricing" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-money-dollar-circle-line text-teal-600 text-lg"></i>
            <span className="text-teal-700 text-sm font-semibold">Transparent Pricing</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            You Only Pay for Space You Use
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Premium service at a better price. No hidden fees, no surprises — just honest, upfront pricing.
          </p>
        </div>

        {/* Minimum Service Call Banner */}
        <div className="max-w-5xl mx-auto mb-12">
          <div className="bg-gradient-to-r from-teal-600 to-emerald-500 rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between text-white shadow-lg">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center">
                <i className="ri-price-tag-3-line text-3xl"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-white/80">Starting At</p>
                <h3 className="text-2xl font-bold">Minimum Service Call</h3>
              </div>
            </div>
            <div className="text-center md:text-right">
              <span className="text-4xl font-extrabold">$120 - $140</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-5xl mx-auto">
          {/* Volume Pricing */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <div className="bg-gray-900 px-8 py-5 flex items-center space-x-3">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-truck-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white">Volume Pricing</h3>
            </div>
            <div className="p-6 space-y-4">
              {volumePricing.map((item, index) => (
                <div key={index} className="group">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-3">
                      <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center group-hover:bg-teal-100 transition-colors">
                        <i className={`${item.icon} text-teal-600 text-base`}></i>
                      </div>
                      <span className="text-gray-800 font-semibold text-sm">{item.label}</span>
                    </div>
                    <span className="text-teal-700 font-bold text-base">{item.price}</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
                    <div className={`${item.fill} h-full bg-gradient-to-r from-teal-500 to-emerald-400 rounded-full transition-all duration-500`}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Single Item Pricing */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <div className="bg-gray-900 px-8 py-5 flex items-center space-x-3">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-archive-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white">Single Item Pricing</h3>
            </div>
            <div className="p-6 space-y-3">
              {singleItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 rounded-xl bg-gray-50 hover:bg-teal-50 transition-colors group"
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm group-hover:bg-teal-100 transition-colors">
                      <i className={`${item.icon} text-teal-600 text-xl`}></i>
                    </div>
                    <span className="text-gray-800 font-semibold text-sm">{item.label}</span>
                  </div>
                  <span className="text-teal-700 font-bold text-base">{item.price}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-14">
          <p className="text-gray-500 text-sm mb-5">
            Prices may vary based on weight, location, and accessibility. Contact us for a free, no-obligation estimate.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={scrollToBooking}
              className="inline-flex items-center space-x-2 bg-teal-600 text-white px-8 py-3.5 rounded-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              <span>Get Your Free Estimate</span>
            </button>
            <a
              href="tel:+19089021076"
              className="inline-flex items-center space-x-2 bg-white text-gray-800 px-8 py-3.5 rounded-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg border border-gray-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg text-teal-600"></i>
              <span>Call (908) 902-1076</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
